export default "__VITE_PUBLIC_ASSET__816b35b6__"